<template>
    <div class="gradeApplication">
      <div class="cont-box">
        <div class="title">
          <Title text="成绩申请" :isShowBack="true" />
          <div>
            <el-form
              ref="search"
              :inline="true"
              :model="condition"
              :rules="searchRules"
              class="search-form"
              slot="search"
              label-width="80px"
            >
                <div style="display: flex; justify-content: space-between">
                    <div>
                        <!-- <div>
                            <el-form-item prop="paper_plan_student_id">
                            <el-select
                                v-model="condition.paper_plan_student_id"
                                placeholder="请选择论文计划"
                                clearable
                                filterable
                                style="width: 300px;"
                            >
                                <el-option
                                v-for="item in thesisPlanList"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id"
                                ></el-option>
                            </el-select>
                            </el-form-item>
                            <el-form-item>
                            <el-button type="primary" @click="loadData">确认</el-button>
                            </el-form-item>
                        </div> -->
                    </div>
                    <div v-if="isShowGradeApplicationBtn">
                        <div class="btn-box">
                            <div>
                                <el-form-item>
                                    <el-button type="primary" @click="gradeApplicationClick">成绩申请</el-button>
                                </el-form-item>
                            </div>
                        </div>
                        <!-- <div>
                            <el-form-item>
                                <span>成绩申请截止时间：{{score_apply_time}}</span>
                            </el-form-item>
                        </div> -->
                    </div>
                </div>
            </el-form>
          </div>
          <div>
            <el-table
                :data="list"
                headerRowClassName="uni-primary-table-header"
                stripe
                border
            >
                <el-table-column prop="paper_plan_title" align="center" label="计划"></el-table-column>
                <el-table-column prop="paper_titlle" align="center" label="论文标题"></el-table-column>
                <el-table-column prop="qa_content" align="center" label="问答内容">
                    <template slot-scope="{row}">
                        <el-button
                            class="link-btn"
                            type="text"
                            @click="QAClick(row)"
                        >查看问答</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="check_status_title" align="center" label="评分状态"></el-table-column>
                <el-table-column prop="check_remark" align="center" label="审核备注"></el-table-column>
                <el-table-column prop="final_score" align="center" label="最终得分"></el-table-column>

                <el-table-column align="center" label="操作" width="200">
                <template v-if="row.check_status==0" slot-scope="{row}">
                    <el-button
                    class="link-btn"
                    type="text"
                    @click="revokeScore(row)"
                    >撤销</el-button>
                </template>
                </el-table-column>
            </el-table>
          </div>
            <!-- 弹窗 成绩申请 第一步 -->
            <el-dialog
                class="applyFormPop"
                title="成绩申请"
                :visible.sync="isShowApplyFormPop"
                width="40%"
                :close-on-click-modal="false"
                @close="applyFormPopClose"
            >
                <div class="dialog" >
                    <div>
                        <el-form
                            ref="applyForm"
                            :model="applyFormData"
                            :rules="applyFormRules"
                            label-width="160px"
                            >
                                <el-tabs v-model="activeName" @tab-click="tabHandle">
                                    <el-tab-pane label="第一步" name="1" :disabled="true">
                                        <el-form-item label="毕业设计(论文)题目" prop="paper_titlle">
                                            <el-input v-model="applyFormData.paper_titlle" placeholder="请输入毕业设计(论文)题目" clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="教师提问1" prop="question1">
                                            <el-input v-model="applyFormData.question1" placeholder="请输入教师提问1" clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="学生回答1" prop="answer1">
                                            <el-input v-model="applyFormData.answer1" placeholder="请输入学生回答1" clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="教师提问2" prop="question2">
                                            <el-input v-model="applyFormData.question2" placeholder="请输入教师提问2" clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="学生回答2" prop="answer2">
                                            <el-input v-model="applyFormData.answer2" placeholder="请输入学生回答2" clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="教师提问3" prop="question3">
                                            <el-input v-model="applyFormData.question3" placeholder="请输入教师提问3" clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="学生回答3" prop="answer3">
                                            <el-input v-model="applyFormData.answer3" placeholder="请输入学生回答3" clearable></el-input>
                                        </el-form-item>
                                    </el-tab-pane>
                                    <el-tab-pane label="第二步" name="2" :disabled="true">
                                        <el-form-item label="最终论文资料:" prop="files_url2">
                                            <!-- ,.zip,.rar,.xls,.xlsx,.doc,.docx,.ppt,.pptx -->
                                            <FalConUpload
                                                ref="uploadFile1"
                                                listStyle='text'
                                                accept=".pdf"
                                                :isFile="true"
                                                :isAccept="false"
                                                @handleRemove="handleRemoveFile($event, 'files_url2')"
                                                @handleChange="handleChangeFile($event, 'files_url2', '1论文', 'uploadFile1', 'applyForm')"
                                            >
                                            </FalConUpload>
                                            <div class="tips">说明：PDF格式文件，文件名为：1论文学号姓名.pdf<br>例如：1论文012201161020张三.pdf</div>
                                        </el-form-item>
                                        <!-- <el-form-item label="任务书:" prop="statement_files2">
                                            <FalConUpload
                                                ref="uploadFile2"
                                                listStyle='text'
                                                accept=".pdf"
                                                :isFile="true"
                                                :isAccept="false"
                                                @handleRemove="handleRemoveFile($event, 'statement_files2')"
                                                @handleChange="handleChangeFile($event, 'statement_files2', '2任务', 'uploadFile2', 'applyForm')"
                                            >
                                            </FalConUpload>
                                            <div class="tips">说明：在系统中下载。PDF格式文件，文件名为：2任务学号姓名.pdf<br>例如：2任务012201161020张三.pdf。</div>
                                        </el-form-item> -->
                                        <el-form-item label="开题报告:" prop="report_files2">
                                            <FalConUpload
                                                ref="uploadFile3"
                                                listStyle='text'
                                                accept=".pdf"
                                                :isFile="true"
                                                :isAccept="false"
                                                @handleRemove="handleRemoveFile($event, 'report_files2')"
                                                @handleChange="handleChangeFile($event, 'report_files2', '2开题', 'uploadFile3', 'applyForm')"
                                            >
                                            </FalConUpload>
                                            <!-- <div class="tips">说明：上传PDF格式的完成后的设计（论文）文件。其中有多个文档的专业请打包压缩为一个文件。</div> -->
                                            <div class="tips">说明：在系统中下载。PDF格式文件，文件名为：2开题学号姓名.pdf<br>例如：2开题012201161020张三.pdf</div>
                                        </el-form-item>
                                        <el-form-item label="查重报告:" prop="duplicate_files2">
                                            <FalConUpload
                                                ref="uploadFile4"
                                                listStyle='text'
                                                accept=".pdf"
                                                :isFile="true"
                                                :isAccept="false"
                                                @handleRemove="handleRemoveFile($event, 'duplicate_files2')"
                                                @handleChange="handleChangeFile($event, 'duplicate_files2', '3查重', 'uploadFile4', 'applyForm')"
                                            >
                                            </FalConUpload>
                                            <!-- <div class="tips">说明：上传PDF格式的完成后的设计（论文）文件。其中有多个文档的专业请打包压缩为一个文件。</div> -->
                                            <div class="tips">说明：PDF格式文件，文件名为：3查重学号姓名.pdf<br>例如：3查重012201161020张三.pdf</div>
                                        </el-form-item>
                                    </el-tab-pane>
                                    <el-tab-pane label="第三步" name="3" :disabled="true">
                                        <el-form-item label="纸质资料递交方式" prop="is_way">
                                            <el-radio-group v-model="applyFormData.is_way">
                                                <el-radio :label="0">到校递交</el-radio>
                                                <el-radio :label="1">邮件递交</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                        <el-form-item label="" prop="is_way">
                                            <div style="color: red;">快递只能用顺丰快递（不要用顺丰同城）</div>
                                        </el-form-item>
                                        <el-form-item v-if="applyFormData.is_way == 0" label="到校地址">
                                            <span style="white-space: break-spaces;">{{ arrivalAddress }}</span>
                                        </el-form-item>
                                        <el-form-item v-if="applyFormData.is_way == 1" label="邮寄地址">
                                            <span style="white-space: break-spaces;">{{ mailingAddress }}</span>
                                        </el-form-item>
                                        <el-form-item v-if="applyFormData.is_way == 1" label="快递凭证" prop="delivery_img">
                                            <FalConUpload
                                                ref="deliveryImg"
                                                :multiple="false"
                                                :isShowModal="false"
                                                @handleRemove="deliveryImgHandleRemove"
                                                @handleChange="deliveryImgHandleChange"
                                            ></FalConUpload>
                                            <div class="tips">*按学校规定快递寄出后的快递单照片</div>
                                        </el-form-item>
                                        <el-form-item label="手写签名:" prop="sign_img">
                                            <esignHandle
                                                ref="applyFormDataEsignHandle"
                                                :selectSignImg.sync="applyFormData.sign_img"
                                                @selectSignImgAfter="studentSignImgAfter($event, 'applyForm', 'sign_img')"
                                            ></esignHandle>
                                        </el-form-item>
                                    </el-tab-pane>
                                </el-tabs>
                        </el-form>
                    </div>
                    <div style="text-align: center">
                        <el-button @click="isShowApplyFormPop = false">取 消</el-button>
                        <!-- :loading="applyFormPopLoading" -->
                        <el-button type="primary" v-if="activeNameNum < 3" @click="nextClick">下一步</el-button>
                        <el-button type="primary" v-if="activeNameNum > 1" @click="previousStepClick">上一步</el-button>
                        <el-button type="primary" v-if="activeNameNum == 3" @click="applyFormPopSubmit">提交</el-button>
                    </div>
                </div>
            </el-dialog>
            <!-- 弹窗 查看问答 -->
            <el-dialog
                class="QA"
                title="查看问答"
                :visible.sync="isShowQAPop"
                width="40%"
                @close="QAPopClose"
            >
                <div class="dialog" >
                    <div>
                        <div v-for="(item, index) in QAData" :key="index">
                            <div class="item">
                                <span class="name">{{'老师提问' + (index + 1)}}:</span>
                                <span class="value">{{ item.question }}</span>
                            </div>
                            <div class="item">
                                <span class="name">{{'学生回答' + (index + 1)}}:</span>
                                <span class="value">{{ item.answer }}</span>
                            </div>
                        </div>
                    </div>
                    <div style="text-align: center">
                        <el-button @click="isShowQAPop = false">取 消</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
      </div>
    </div>
  </template>

  <script>
  import {
    adultStudentPpAll,
    studentGetScoreApply,
    ppsScoreApply,
    revokeScoreApply,
  } from "@/api/graduation";
  import FalConUpload from "@/components/uploadFile";
  import { putObject, uploadFiles, deleteObject } from "@/utils/upload";

  import {deepClone} from '@/utils/func';

  import esignHandle from '@/components/esignHandle';

  export default {
    name: "gradeApplication",
    components: { FalConUpload, esignHandle },
    data() {
      return {
        condition: {
          paper_plan_student_id: this.$route.query.id,  //论文计划
        },
        searchRules: {
          paper_plan_student_id: [{ required: true, message: "请选择论文计划", trigger: "change" }],
        },

        thesisPlanList: [],  //论文计划列表
        list:[],
        listTotal: -1,
        isShowGradeApplicationBtn: true,  //显示 成绩申请 按钮

        // 弹窗 成绩申请
        isShowApplyFormPop: false,
        applyFormPopLoading: false,  //提交等待
        applyFormData: {
            paper_plan_student_id: '',  //论文计划学生id
            paper_titlle: '',  //毕业设计(论文)题目
            question1: '',  //教师提问1
            answer1: '',  //学生回答1
            question2: '',  //教师提问2
            answer2: '',  //学生回答2
            question3: '',  //教师提问3
            answer3: '',  //学生回答3
            qa_content: '',  //问答内容(这里将单个问答组装起来)
            is_way: 0,  //资料递交方式 0到校递交 1邮寄
            delivery_img: '',  //快递单照片
            delivery_img2: '',
            files_url: '',  //最终设计资料
            files_url2: '',
            sign_img: '',  //手写签名
            // statement_files: '',  //任务书
            // statement_files2: '',
            report_files: '',  //开题报告
            report_files2: '',
            duplicate_files: '',  //查重报告
            duplicate_files2: '',
        },
        applyFormRules: {
            paper_titlle: [{ required: true, message: "请输入毕业设计(论文)题目", trigger: "blur" }],
            question1: [{ required: true, message: "请输入教师提问1", trigger: "blur" }],
            answer1: [{ required: true, message: "请输入学生回答1", trigger: "blur" }],
            // question2: [{ required: true, message: "请输入教师提问2", trigger: "blur" }],
            // answer2: [{ required: true, message: "请输入学生回答2", trigger: "blur" }],
            // question3: [{ required: true, message: "请输入教师提问3", trigger: "blur" }],
            // answer3: [{ required: true, message: "请输入学生回答3", trigger: "blur" }],
            is_way: [{ required: true, message: "请选择资料递交方式", trigger: "change" }],
            sign_img: [{ required: true, message: "请添加手写签名", trigger: "change" }],
            files_url2: [{ required: true, message: "请选择最终设计资料", trigger: "change" }],
            // statement_files2: [{ required: true, message: "请选择任务书", trigger: "change" }],
            report_files2: [{ required: true, message: "请选择开题报告", trigger: "change" }],
            duplicate_files2: [{ required: true, message: "请选择查重报告", trigger: "change" }],
        },
        activeName: '1',  //成绩申请 步骤
        activeNameNum: 1,  //activeName转数字

        //重庆市江北区观音桥信一金典五楼派瑞教育（一办公室），陈静收，电话17702342890
        arrivalAddress: '重庆医科大学继教院\n收件人：xx老师\n电话：12345789',  //到校地址
        mailingAddress: '重庆医科大学继教院\n收件人：xx老师\n电话：12345789',  //邮寄地址

        // 弹窗 查看问答
        isShowQAPop: false,
        QAData: [],

        // score_apply_time: '',  //成绩申请截止时间
        student_code: '',  //学号
        student_title: '',  //姓名

      };
    },
    async created() {
        await this.getThesisPlanList();
        this.loadData();
    },
    methods: {
        // 点击查看问答
        QAClick(row){
            this.QAData = JSON.parse(row.qa_content);
            this.isShowQAPop = true;
        },
        // 弹窗 查看问答 关闭
        QAPopClose(){
            this.QAData = [];
        },
        //tab切换
        tabHandle(v){
        //    console.log(v);
        },
        // 上一步
        previousStepClick(){
            this.activeNameNum -= 1;
            this.activeName = this.activeNameNum.toString();
        },
        // 下一步
        nextClick(){
            if(this.activeName == '1'){
                const propList = ['paper_titlle', 'question1', 'answer1', 'question2', 'answer2', 'question3', 'answer3'];
                let num = 0;
                this.$refs["applyForm"].validateField(propList, (valid) => {
                    if (!valid) {
                        num += 1;
                    }
                });
                if(num == propList.length){
                    this.activeNameNum += 1;
                    this.activeName = this.activeNameNum.toString();
                }
            }else if(this.activeName == '2'){
                // 'statement_files2',
                const propList = ['files_url2', 'report_files2', 'duplicate_files2'];
                let num = 0;
                this.$refs["applyForm"].validateField(propList, (valid) => {
                    if (!valid) {
                        num += 1;
                    }
                });
                if(num == propList.length){
                    this.activeNameNum += 1;
                    this.activeName = this.activeNameNum.toString();
                }
            }
        },
        // 弹窗 成绩申请 提交
        applyFormPopSubmit(){
            this.$refs["applyForm"].validate((valid) => {
                if (valid) {
                    this.applyFormPopLoading = true;
                    // console.log(this.applyFormData);
                    let upload1 = new Promise((resolve, reject) => {
                        uploadFiles(this.applyFormData.files_url2, (urls) => {
                            resolve(urls);
                        }, null, 'student', '', true);
                    });
                    let upload2 = new Promise((resolve, reject) => {
                        putObject(this.applyFormData.delivery_img2, (urls) => {
                            resolve(urls);
                        }, null, 'student', '', true);
                    });
                    // let upload3 = new Promise((resolve, reject) => {
                    //     uploadFiles(this.applyFormData.statement_files2, (urls) => {
                    //         resolve(urls);
                    //     }, null, 'student', '', true);
                    // });
                    let upload4 = new Promise((resolve, reject) => {
                        uploadFiles(this.applyFormData.report_files2, (urls) => {
                            resolve(urls);
                        }, null, 'student', '', true);
                    });
                    let upload5 = new Promise((resolve, reject) => {
                        uploadFiles(this.applyFormData.duplicate_files2, (urls) => {
                            resolve(urls);
                        }, null, 'student', '', true);
                    });
                    // upload3,
                    Promise.all([upload1, upload2, upload4, upload5]).then(urlList => {
                        let data = deepClone(this.applyFormData);
                        let files_url = urlList[0];
                        let delivery_img = urlList[1];
                        // let statement_files = urlList[2];
                        let report_files = urlList[2];
                        let duplicate_files = urlList[3];
                        let qa_content = [
                            {question: data.question1, answer: data.answer1},
                            {question: data.question2, answer: data.answer2},
                            {question: data.question3, answer: data.answer3},
                        ];
                        let queryData = {
                            paper_plan_student_id: data.paper_plan_student_id,
                            paper_titlle: data.paper_titlle,
                            qa_content: JSON.stringify(qa_content),
                            is_way: data.is_way,
                            delivery_img: delivery_img,
                            files_url: files_url,
                            sign_img: data.sign_img,
                            // statement_files,
                            report_files,
                            duplicate_files,
                        };
                        // console.log(queryData);
                        ppsScoreApply(queryData).then(res => {
                            if(res.code == 200){
                                this.$message.success('操作成功');
                                this.isShowApplyFormPop = false;
                                // this.isShowGradeApplicationBtn = false;
                                this.getThesisPlanList().then(ress => {
                                    this.gradeApplicationBtnHandle();
                                })
                                this.loadData();
                            }
                        }).finally(() => {
                            this.applyFormPopLoading = false;
                        });
                    })
                }
            })
        },
        // 点击成绩申请
        gradeApplicationClick(){
            this.applyFormData.paper_plan_student_id = this.condition.paper_plan_student_id;
            this.isShowApplyFormPop = true;
        },
        // 弹窗 成绩申请 关闭
        applyFormPopClose(){
            this.applyFormData = {
                paper_plan_student_id: '',  //论文计划学生id
                paper_titlle: '',  //毕业设计(论文)题目
                question1: '',  //教师提问1
                answer1: '',  //学生回答1
                question2: '',  //教师提问2
                answer2: '',  //学生回答2
                question3: '',  //教师提问3
                answer3: '',  //学生回答3
                qa_content: '',  //问答内容(这里将单个问答组装起来)
                is_way: 0,  //资料递交方式 0到校递交 1邮寄
                delivery_img: '',  //快递单照片
                files_url: '',  //最终设计资料
                files_url2: '',
                sign_img: '',  //手写签名
                // statement_files: '',  //任务书
                // statement_files2: '',
                report_files: '',  //开题报告
                report_files2: '',
                duplicate_files: '',  //查重报告
                duplicate_files2: '',
            };
            if(this.applyFormData.is_way == 1){
                this.$refs['deliveryImg'].reset();
            }
            this.$refs['uploadFile1'].reset();
            // this.$refs['uploadFile2'].reset();
            this.$refs['uploadFile3'].reset();
            this.$refs['uploadFile4'].reset();
            this.$refs['applyFormDataEsignHandle'].handleReset();  //签名这块清空
            this.$nextTick(() => {
                this.$refs["applyForm"].clearValidate();
                this.activeName = '1';
                this.activeNameNum = 1;
            });
        },
        // 弹窗 签名成回调
        studentSignImgAfter(v, refName, field) {
            this.$refs[refName].validateField(field);
        },
        // 弹窗 成绩申请 上传
        handleChangeFile(data, keyName, type, fileRef, refName) {
            const fileName = data.file.name.toLowerCase();
            // const fileName2 = fileName.split('.')[0];
            const fileTitle = `${type}${this.student_code}${this.student_title}.pdf`;
            if(fileName == fileTitle){
                this.applyFormData[keyName] = data.fileList;
                this.$refs[refName].validateField(keyName);
            }else{
                this.$message.error(`请按要求设置文件名,当前文件名：${fileName}`);
                console.log(`文件名:${data.file.name}`);
                console.log(`格式要求名:${fileTitle}`);
                this.applyFormData[keyName] = [];
                this.$refs[fileRef].handleRemove('', []);
                // let currItem = this.applyFormData[keyName].findIndex(item.name == data.file.name);
                // console.log(currItem);
            }
        },
        // 弹窗 成绩申请 删除
        handleRemoveFile(data, keyName) {
            this.applyFormData[keyName] = data.fileList;
        },
        // 弹窗 成绩申请 快递凭证
        deliveryImgHandleChange(data){
            this.applyFormData.delivery_img2 = data.file;
        },
        //弹窗 成绩申请  快递凭证 删除
        deliveryImgHandleRemove(data){
            this.applyFormData.delivery_img2 = '';
        },
        // 获取数据
        getListFn(){
            let data = {
                paper_plan_student_id: this.condition.paper_plan_student_id
            };
            studentGetScoreApply(data).then(res => {
                if(res.code == 200){
                    this.list = res.result;
                }
            });
        },
        // 选择资料确认
        loadData(){
            this.$refs["search"].validate((valid) => {
                if (valid) {
                    this.getListFn();
                    this.gradeApplicationBtnHandle();
                }
            });
        },
        // 处理 申请按钮
        gradeApplicationBtnHandle(){
            let curItem = this.thesisPlanList.find(item => item.id == this.condition.paper_plan_student_id);
            // this.score_apply_time = curItem.score_apply_time;
            // this.score_reply_deadline = curItem.score_reply_deadline;
            if(curItem.process_status >= 5){
                this.isShowGradeApplicationBtn = true;
            }else{
                this.isShowGradeApplicationBtn = false;
            }
            this.student_title = curItem.student_title;
            this.student_code = curItem.student_code;
        },
        // 获取论文计划
        getThesisPlanList(){
            return new Promise((resolve, reject) => {
                adultStudentPpAll().then(res => {
                    this.thesisPlanList = res.result;
                    resolve();
                });
            })

        },
        // 撤销
        revokeScore(row) {
            this.$confirm('是否确定要撤销该申请？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    id: row.id,
                };
                revokeScoreApply(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success('操作成功');
                        this.getThesisPlanList().then(ress => {
                            this.gradeApplicationBtnHandle();
                        })
                        this.loadData();
                    }
                })
            })
        },
    },
    beforeDestroy() {

    },
  };
  </script>

  <style lang="scss" scoped>
  .gradeApplication {
    min-height: $contentH;
    padding: $sideMargin;
    padding-bottom: 0;
    .cont-box{
      background: $white;
      min-height: inherit;
      padding: 0 20px 20px;
    }
    .QA{
        .item{
        padding: 5px 0;
        .value{
            font-weight: bold;
            margin-left: 10px;
        }
        }
    }
  }
  </style>
